// "Jump to" table-of-contents for long content pages. Pass items as
// [{ id, label }] where each id matches a section's id on the page.
export default function JumpNav({ items }) {
  if (!items?.length) return null
  return (
    <nav className="jumpnav" aria-label="On this page">
      <span className="jumpnav-title">Jump to</span>
      <div className="jumpnav-links">
        {items.map((i) => <a key={i.id} href={`#${i.id}`}>{i.label}</a>)}
      </div>
    </nav>
  )
}
